<template>
  <div>
    <ul v-if="profil != undefined">
      <li>Nom : {{ profil.name }}</li>
      <li>Prénom : {{ profil.surname }}</li>
      <li>Genre : {{ profil.gender }}</li>
      <li>Niveau de formation/Diplôme : {{ profil.studiesLevel }}</li>
      <li>Intitulé du poste : {{ profil.position }}</li>
      <li>Nature : {{ profil.rdoNatureService }}</li>
      <li>Statut : {{ profil.rdoNatureStatus }} - {{ profil.natureOther }}</li>
      <li>Nombre de personnes encadrées : {{ profil.supportingNumber }}</li>
      <li>Entreprise / Établissement : {{ profil.supportingNumber }}</li>
      <li>Ancienneté : {{ profil.experience }}</li>
      <li>Type CCTI/MBTI : {{ profil.CCTI_MBTI }}</li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    profil: {
      type: Object,
      default: undefined,
    },
  },
};
</script>

<style lang="scss" scoped></style>
